import React from 'react';

const standardSizes = {
  HANGTEN: ['24','25','26','27','28','29','30','31','32','34','36','38','XS','S','M','L','XL','XXL','2XL'],
  PRETTYFIT: ['35','36','37','38','39','40'],
};
const alphaSizes = ['XS','S','M','L','XL','XXL','2XL','3XL'];
export const totalQty = plan => (plan?.items || []).reduce((sum, item) => sum + Number(item.qty || 0), 0);
export const codeOf = item => item.productCode ?? item.product_code;
export function transferMatrix(plan) {
  const sizes = [...new Set([...(standardSizes[plan.brand] || []), ...plan.items.map(i => String(i.size))])].sort((a, b) => {
    const x = Number(a), y = Number(b);
    if (Number.isFinite(x) && Number.isFinite(y)) return x - y;
    if (Number.isFinite(x)) return -1;
    if (Number.isFinite(y)) return 1;
    return (alphaSizes.indexOf(a) < 0 ? 99 : alphaSizes.indexOf(a)) - (alphaSizes.indexOf(b) < 0 ? 99 : alphaSizes.indexOf(b)) || a.localeCompare(b);
  });
  const rows = new Map();
  for (const item of plan.items) {
    const key = `${codeOf(item)}\u0000${item.color}`;
    if (!rows.has(key)) rows.set(key, { code: codeOf(item), color: item.color, sizes: {}, total: 0 });
    const row = rows.get(key);
    row.sizes[item.size] = (row.sizes[item.size] || 0) + Number(item.qty || 0);
    row.total += Number(item.qty || 0);
  }
  return { sizes, rows: [...rows.values()] };
}
export function myanmarReason(item, plan) {
  const from = plan.fromLocationCode ?? plan.from_location_code;
  const to = plan.toLocationCode ?? plan.to_location_code;
  const source = Number(item.sourceBefore ?? item.source_before);
  const destination = Number(item.destinationBefore ?? item.destination_before);
  const quantity = Number(item.qty);
  if ((item.sourceBefore ?? item.source_before) != null && (item.destinationBefore ?? item.destination_before) != null &&
      [source, destination, quantity].every(Number.isFinite) && quantity > 0 && source >= quantity) {
    const need = destination === 0 ? `${item.size} Size မရှိပါ` : `${item.size} Size ${destination} ထည်ပဲ ရှိပါတယ်`;
    return `${codeOf(item)} အရောင် ${item.color} ${item.size} Size ကို ${to} ဆိုင်သို့ ${quantity} ထည် ပို့ပေးသင့်ပါတယ်။ ${to} ဆိုင်မှာ ${need}။ စာရင်းထုတ်ချိန် ${from} မှာ ${source} ထည် ရှိပါတယ်။`;
  }
  return `${from} → ${to} အတွက် ${codeOf(item)} / ${item.color} / ${item.size} ကို ${item.qty} ထည် ပို့ရန် အကြံပြုထားပါသည်။ လက်ရှိ stock ကို ပြန်စစ်ပြီးမှ ပို့ပါ။`;
}
export default function TransferSizeMatrix({ plan, className = 'warehouseAllocation__matrix' }) {
  const matrix = transferMatrix(plan);
  return <table className={className} aria-label="Transfer size matrix">
    <colgroup><col style={{ width:'4%' }} /><col style={{ width:'21%' }} /><col style={{ width:'7%' }} />{matrix.sizes.map(size => <col key={size} style={{ width:`${60 / matrix.sizes.length}%` }} />)}<col style={{ width:'8%' }} /></colgroup>
    <thead><tr><th rowSpan="2">No.</th><th rowSpan="2">Article Number</th><th rowSpan="2">Colour</th><th colSpan={matrix.sizes.length}>Sizes</th><th rowSpan="2">Quantity</th></tr><tr>{matrix.sizes.map(size => <th key={size}>{size}</th>)}</tr></thead>
    <tbody>{matrix.rows.map((row, index) => <tr key={`${row.code}|${row.color}`}><td>{index + 1}</td><td>{row.code}</td><td>{row.color}</td>{matrix.sizes.map(size => <td key={size}>{row.sizes[size] || ''}</td>)}<td><b>{row.total}</b></td></tr>)}</tbody>
    <tfoot><tr><td colSpan={3 + matrix.sizes.length}>Total</td><td>{totalQty(plan)}</td></tr></tfoot>
  </table>;
}
